import { Navigate, useLocation } from 'react-router-dom'
import { Spinner } from '@fluentui/react-components'
import { useAuth } from '../context/AuthContext'
import type { ReactNode } from 'react'

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { token, loading } = useAuth()
  const location = useLocation()

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spinner size="large" label="Loading..." />
      </div>
    )
  }

  if (!token) {
    // Remember where the user was headed so login can return them THERE after
    // SSO — not dump them on the app home. Critical for standalone deep links
    // like /submit-demand, which should stay standalone across the login round
    // trip. Carried via router state → Login → backend `redirect_url`.
    const from = `${location.pathname}${location.search}`
    return <Navigate to="/login" state={{ from }} replace />
  }

  return <>{children}</>
}
